import { underLoadingFunction } from '@/store/helpers/under-loading'
import AtestadoService from '@/services/atestado-service'
import * as MutationTypes from './mutation-types'
import { TiposDocumentos } from '../../mixins/tipos-documentos'

export default {
  state: {
    emitirAtestado: {
      finalidades: [],
      post: [],
      buttonDisabled: true,
      resposta: null,
      combos: []
    }
  },
  mutations: {
    [MutationTypes.SET_ATESTADO_RESPOSTA] (state, payload) {
      state.emitirAtestado.resposta = payload
    },
    [MutationTypes.SET_ATESTADO_DADOS] (state, payload) {
      state.emitirAtestado.post = payload
    },
    [MutationTypes.DESABILITAR_BOTAO_ENVIAR] (state, payload) {
      state.emitirAtestado.buttonDisabled = payload
    },
    [MutationTypes.SET_ATESTADO_FINALIDADES] (state, payload) {
      state.emitirAtestado.finalidades = payload
    },
    [MutationTypes.LISTAS_APOIO_ATESTADO] (state, payload) {
      state.emitirAtestado.combos = payload
    }
  },
  actions: {
    getAtestadoFinalidades: underLoadingFunction(async ({ commit }) => {
      const response = await AtestadoService.getFinalidades(TiposDocumentos.Atestado)
      commit(MutationTypes.SET_ATESTADO_FINALIDADES, response.data)
    }),
    getCombosAction: underLoadingFunction(async ({ commit }) => {
      const response = await AtestadoService.getCombos()
      commit(MutationTypes.LISTAS_APOIO_ATESTADO, response.data)
    }),
    solicitarAtestadoCadeiraRodas: underLoadingFunction(async ({ commit }, payload) => {
      const response = await AtestadoService.solicitarAtestadoCadeiraRodas(payload)
      commit(MutationTypes.SET_ATESTADO_RESPOSTA, response.data)
    }),
    solicitarSeloAcessibilidade: underLoadingFunction(async ({ commit }, payload) => {
      const response = await AtestadoService.solicitarSeloAcessibilidade(payload)
      commit(MutationTypes.SET_ATESTADO_RESPOSTA, response.data)
    }),
    solicitarFraldas: underLoadingFunction(async ({ commit }, payload) => {
      const response = await AtestadoService.solicitarFraldas(payload)
      commit(MutationTypes.SET_ATESTADO_RESPOSTA, response.data)
    }),
    solicitarAtestadoInternacoes: underLoadingFunction(async ({ commit }, payload) => {
      const response = await AtestadoService.solicitarAtestadoInternacoes(payload)
      commit(MutationTypes.SET_ATESTADO_RESPOSTA, response.data)
    }),
    solicitarAtestadoComparecimento: underLoadingFunction(async ({ commit }, payload) => {
      const response = await AtestadoService.solicitarAtestadoComparecimento(payload)
      commit(MutationTypes.SET_ATESTADO_RESPOSTA, response.data)
    }),
    solicitarDeclaracaoAtendimentos: underLoadingFunction(async ({ commit }, payload) => {
      const response = await AtestadoService.solicitarDeclaracaoAtendimentos(payload)
      commit(MutationTypes.SET_ATESTADO_RESPOSTA, response.data)
    })
  },
  getters: {
    getRespostaAtestado (state) {
      return state.emitirAtestado.resposta
    },
    getFinalidades (state) {
      return state.emitirAtestado.finalidades
    },
    getCombosResponse (state) {
      return state.emitirAtestado.combos
    },
    getDadosAtestado (state) {
      return state.emitirAtestado.post
    },
    getButtonDisabled (state) {
      return state.emitirAtestado.buttonDisabled
    }
  }
}
